import { render, staticRenderFns } from "./CloseReport.vue?vue&type=template&id=e45664a0&scoped=true"
import script from "./CloseReport.vue?vue&type=script&lang=js"
export * from "./CloseReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45664a0",
  null
  
)

export default component.exports